import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SubscriptionControlLayer from "../components/SubscriptionControlLayer";
import SubscriptionPlansLayer from "../components/SubscriptionPlansLayer";

const SubscriptionControlPage = () => {
  const [activeTab, setActiveTab] = useState('venues'); // 'venues' | 'plans'

  return (
    <MasterLayout>
      <Breadcrumb title="Subscription Management" />
      
      <div className="d-flex align-items-center gap-2 mb-24">
        <button 
          type="button"
          className="btn btn-sm radius-8 px-4 py-2 fw-semibold d-inline-flex align-items-center gap-2"
          style={{
            backgroundColor: activeTab === 'venues' ? '#E0F2FE' : '#ffffff',
            color: activeTab === 'venues' ? '#0388d6' : '#475569',
            border: activeTab === 'venues' ? '1px solid #bae6fd' : '1px solid #e2e8f0',
            boxShadow: activeTab === 'venues' ? '0 1px 3px rgba(3, 136, 214, 0.12)' : 'none'
          }}
          onClick={() => setActiveTab('venues')}
        >
          Venue Subscriptions
        </button>

        <button 
          type="button"
          className="btn btn-sm radius-8 px-4 py-2 fw-semibold d-inline-flex align-items-center gap-2"
          style={{
            backgroundColor: activeTab === 'plans' ? '#E0F2FE' : '#ffffff',
            color: activeTab === 'plans' ? '#0388d6' : '#475569',
            border: activeTab === 'plans' ? '1px solid #bae6fd' : '1px solid #e2e8f0',
            boxShadow: activeTab === 'plans' ? '0 1px 3px rgba(3, 136, 214, 0.12)' : 'none'
          }}
          onClick={() => setActiveTab('plans')}
        >
          Subscription Plans
        </button>
      </div>

      {activeTab === 'venues' ? <SubscriptionControlLayer /> : <SubscriptionPlansLayer />}
    </MasterLayout>
  );
};

export default SubscriptionControlPage;
